export default class Salary {

  errorMessage = 'Informe seu salário bruto mensal.'
  placeholder = 'R$ 0,00'

  getOnlyNumbers(text) {
    return text.replace(/[\D]/g, '')
  }

  getDecimalNumber(text) {
    return text.replace(/[^\d\,]/g, '')
  }

  getFloatNumber(text) {
    const num1 = this.getDecimalNumber(text)
    const num2 = num1.replace(/\,/g, '.')
    return parseFloat(num2)
  }

  valid(value, min = null, max = null) {
    value = this.getFloatNumber(value)
    if (min !== null && max !== null) {
      return value >= min && value < max
    } else if (min !== null) {
      return value >= min
    } else {
      return value >= 100
    }
  }

  error(value, min = null, max = null) {
    if (this.getOnlyNumbers(value) > 0) {
      return !this.valid(value, min, max)
    }
    return this.valid(value, min, max)
  }

}
